'use client';
import { useRef } from 'react';

// styles
import styles from './description.module.scss';

// next image
import Image from 'next/image';

// framer-motion
import { useInView, useScroll, useTransform, motion } from 'framer-motion';

// components
import T from '../../../common/components/T';

// classnames
import classNames from 'classnames';

const DescriptionPage = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    const { scrollYProgress } = useScroll({ target: ref });
    const x = useTransform(scrollYProgress, [0, 1], ['100%', '-100%']);
    return (
        <motion.div className={styles.descriptionWrapper} ref={ref} initial={'hidden'} whileInView={'visible'}>
            <motion.div
                className={styles.iconWrapper}
                initial={{ scale: 0, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{
                    duration: 0.25,
                    ease: 'linear'
                }}
                style={{ transformOrigin: 'center' }}
                viewport={{ once: true }}
            >
                <motion.div
                    className={styles.descriptionGradient}
                    // style={{
                    //     transition: 'transform 0.5s linear 0.5s',
                    //     scale: !isInView ? 0 : 2,
                    //     opacity: !isInView ? 0 : 1
                    // }}
                    initial={{ scale: 0.1, backgroundColor: 'rgba(177, 138, 75, 0.1)' }}
                    //animate={{ scale: 1, opacity: 1 }}
                    whileInView={{ scale: 3, backgroundColor: '#FBF9F6' }}
                    transition={{
                        duration: 0.25,
                        ease: 'linear'
                    }}
                    //style={{ transformOrigin: 'center' }}
                    viewport={{ once: true, amount: 0.25 }}
                />
                <Image
                    width={698}
                    height={698}
                    className={styles.iconWrapperLogo}
                    src={'/src/landing/description/icon.svg'}
                    alt='bg icon'
                />
                <motion.div
                    className={classNames(styles.iconWrapperLogoBorder, styles.iconWrapperLogoBorder_01)}
                    initial={{ scale: 0, opacity: 0 }}
                    //animate={{ scale: 1, opacity: 1 }}
                    whileInView={{ scale: 1, opacity: 1 }}
                    // style={{
                    //     transition: 'opacity 0.5s linear 2s, scale 0.5s linear 2s'
                    //     //opacity: !isInView ? 0 : 1
                    // }}
                    transition={{
                        duration: 0.25,
                        ease: 'linear'
                    }}
                    //viewport={{ once: true }}
                >
                    {' '}
                </motion.div>
                <motion.div
                    className={classNames(styles.iconWrapperLogoBorder, styles.iconWrapperLogoBorder_02)}
                    initial={{ scale: 0, opacity: 0 }}
                    //animate={{ scale: 1, opacity: 1 }}
                    whileInView={{ scale: 1, opacity: 1 }}
                    // style={{
                    //     transition: 'opacity 0.5s linear 2.5s, scale 0.5s linear 2.5s'
                    //     //opacity: !isInView ? 0 : 1
                    // }}
                    transition={{
                        duration: 0.25,
                        ease: 'linear'
                    }}
                    //viewport={{ once: true }}
                >
                    {' '}
                </motion.div>
            </motion.div>

            <motion.div
                className={styles.ellips1Wrapper}
                // style={{
                //     transition: 'transform 1s linear 3s',
                //     y: !isInView ? '-140%' : 0,
                //     x: !isInView ? '50%' : 0
                // }}
                initial={{ y: '-140%', x: '50%', opacity: 0 }}
                whileInView={{ y: 0, x: 0, opacity: 1 }}
                transition={{
                    duration: 0.25,
                    ease: 'linear'
                }}
                //viewport={{ once: true }}
            >
                <Image src={'ellipse.svg'} alt='ellipse icon3' width={220} height={220} />
            </motion.div>
            <motion.div
                className={styles.ellips2Wrapper}
                style={{
                    transition: 'transform 0.5s linear',
                    x: !isInView ? '100%' : 0
                }}
            >
                {/* Без CSS transition: x обновляется на каждом кадре скролла, и Safari
                    перезапускал transition каждый кадр — скролл дёргался. */}
                <motion.div style={{ x }}>
                    <Image src={'ellipse.svg'} alt='ellipse icon4' width={268} height={268} />
                </motion.div>
            </motion.div>
            <motion.div
                className={styles.ellips3Wrapper}
                style={{
                    transition: 'transform 0.25s linear',
                    y: !isInView ? '140%' : 0,
                    x: !isInView ? '50%' : 0
                }}
            >
                <Image src={'ellipse.svg'} alt='ellipse icon3' width={220} height={220} />
            </motion.div>
            <motion.div
                className={styles.ellips4Wrapper}
                style={{
                    transition: 'transform 0.5s linear',
                    y: !isInView ? '150%' : 0,
                    x: !isInView ? '30%' : 0
                }}
            >
                <Image src={'ellipse.svg'} alt='ellipse icon5' width={377} height={377} />
            </motion.div>
            <div className={styles.titleBlock}>
                <div className={styles.descriptionTextWrapper}>
                    <motion.h2
                        className={styles.descriptionText}
                        style={{
                            transition: 'transform 0.4s linear 0.25s',
                            y: !isInView ? '110%' : 0
                        }}
                    >
                        <T textName={'landing-descrippage-new1'} defaultStr={'Не просто продукты,'} page='/' />
                    </motion.h2>
                </div>
                <div className={styles.descriptionTextWrapper}>
                    <motion.h2
                        className={styles.descriptionText}
                        style={{
                            transition: 'transform 0.4s linear 0.25s',
                            y: !isInView ? '110%' : 0
                        }}
                    >
                        <T textName={'landing-descrippage-new2'} defaultStr={'а искусство жить!'} page='/' />
                    </motion.h2>
                </div>
            </div>
            <div className={styles.textBlock}>
                <div className={styles.textWrapper}>
                    <motion.p
                        className={styles.textMain}
                        style={{
                            transition: 'transform 0.4s linear 0.25s',
                            y: !isInView ? '110%' : 0
                        }}
                    >
                        <T
                            textName={'landing-descrippage-new3'}
                            defaultStr={'Global Trend это олицетворение роскоши и'}
                            page='/'
                        />
                    </motion.p>
                </div>
                <div className={styles.textWrapper}>
                    <motion.p
                        className={styles.textMain}
                        style={{
                            transition: 'transform 0.4s linear 0.25s',
                            y: !isInView ? '110%' : 0
                        }}
                    >
                        <T
                            textName={'landing-descrippage-new4'}
                            defaultStr={'качества. Наши продукты созданы для тех, кто'}
                            page='/'
                        />
                    </motion.p>
                </div>
                <div className={styles.textWrapper}>
                    <motion.p
                        className={styles.textMain}
                        style={{
                            transition: 'transform 0.4s linear 0.25s',
                            y: !isInView ? '110%' : 0
                        }}
                    >
                        <T
                            textName={'landing-descrippage-new5'}
                            defaultStr={'ценит лучшее и стремится к совершенству!'}
                            page='/'
                        />
                    </motion.p>
                </div>
            </div>
        </motion.div>
    );
};
export default DescriptionPage;
